// extracted by mini-css-extract-plugin
export default {"dropdown":"Menu_dropdown__-viFm","item":"Menu_item__x+20N","items":"Menu_items__zQ8w8"};